module.exports = __webpack_public_path__ + "fonts/MyriadPro-BoldCondIt.b59eeda.ttf";